"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_IN_PROGRESS_TO_EVENT_NAME_MAP = exports.SUBSCRIPTION_EVENT_TYPE = exports.TEST_SUBSCRIPTION_DESCRIPTION_KEYWORDS = exports.SKIP_WEBHOOK_CUSTOMER_EMAIL = exports.MANAGED_BY = exports.GLOBAL_SUBSCRIPTION_PURCHASES_VARIANCE = exports.USER_ID_WITH_PREMIUM_SUBSCRIPTION = exports.GOSTUDENT_SUBSCRIPTION_NAME = exports.SOMOS_SUBSCRIPTION_NAME = exports.SOMOS_SUBSCRIPTION_TYPES = exports.Publishers = exports.VAT_RATE = exports.PRODUCT_TIERS_SOMOS = exports.PRODUCT_TIERS = exports.PAYMENT_IN_PROGRESS_STATES = exports.STRIPE_BILLING_REASONS = exports.STRIPE_SUBSCRIPTION_STATES = exports.STRIPE_PAYMENT_FAILED_ERROR_CODES = exports.PAYMENT_INTENT_STATUS = exports.SUBSCRIPTION_PAYMENT_STATUS = exports.SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_EXPIRY_DATES = exports.PAYMENT_METHOD = exports.REQUIRED_ACTION = exports.EXTERNAL_PUBLISHERS_AUTH_PROVIDER = void 0;
const subscriptionUpdate_1 = require("./subscriptionUpdate");
__exportStar(require("./CouponType"), exports);
// duplicate of a const from @seneca/authentication-library/out/consts to avoid pulling in Firebase
exports.EXTERNAL_PUBLISHERS_AUTH_PROVIDER = Object.freeze({
    'oidc.plurall': 'SOMOS',
    'oidc.gostudent': 'GOSTUDENT',
    'oidc.studienkreis': 'STUDIENKREIS'
});
exports.REQUIRED_ACTION = Object.freeze({
    '3DS': '3DS'
});
exports.PAYMENT_METHOD = Object.freeze({
    googlePay: 'googlePay',
    applePay: 'applePay',
    card: 'card'
});
exports.SUBSCRIPTION_EXPIRY_DATES = Object.freeze({
    monthly: 'monthly',
    seasonal: 'seasonal',
    annually: 'annually'
});
exports.SUBSCRIPTION_STATUS = Object.freeze({
    active: 'active',
    paused: 'paused',
    cancelled: 'cancelled',
    pending: 'pending',
    unpausing: 'unpausing'
});
exports.SUBSCRIPTION_PAYMENT_STATUS = Object.freeze({
    succeeded: 'succeeded',
    failed: 'failed',
    requiresAction: 'requiresAction'
});
exports.PAYMENT_INTENT_STATUS = Object.freeze({
    succeeded: 'succeeded',
    requires_payment_method: 'requires_payment_method',
    requires_action: 'requires_action',
    canceled: 'canceled'
});
exports.STRIPE_PAYMENT_FAILED_ERROR_CODES = Object.freeze({
    card_declined: 'card_declined',
    expired_card: 'expired_card'
});
exports.STRIPE_SUBSCRIPTION_STATES = Object.freeze({
    active: 'active',
    canceled: 'canceled',
    incomplete: 'incomplete',
    incompleteExpired: 'incomplete_expired',
    unpaid: 'unpaid',
    pastDue: 'past_due',
    trialing: 'trialing'
});
exports.STRIPE_BILLING_REASONS = Object.freeze({
    cycle: 'subscription_cycle',
    create: 'subscription_create',
    update: 'subscription_update'
});
exports.PAYMENT_IN_PROGRESS_STATES = Object.freeze({
    upgrade: 'upgrade',
    create: 'create'
});
exports.PRODUCT_TIERS = Object.freeze({
    essential: 'essential',
    supreme: 'supreme',
    examBoost: 'examBoost',
    aiAssistant: 'aiAssistant',
    tutoring: 'tutoring',
    guarantee: 'guarantee'
});
exports.PRODUCT_TIERS_SOMOS = Object.freeze({
    somos: 'SOMOS'
});
exports.VAT_RATE = 0.2;
exports.Publishers = Object.values(exports.EXTERNAL_PUBLISHERS_AUTH_PROVIDER).reduce((acc, publisher) => ({ ...acc, [publisher]: publisher }), {});
var SOMOS_SUBSCRIPTION_TYPES;
(function (SOMOS_SUBSCRIPTION_TYPES) {
    SOMOS_SUBSCRIPTION_TYPES["freemium"] = "Freemium";
    SOMOS_SUBSCRIPTION_TYPES["premium"] = "Premium";
})(SOMOS_SUBSCRIPTION_TYPES = exports.SOMOS_SUBSCRIPTION_TYPES || (exports.SOMOS_SUBSCRIPTION_TYPES = {}));
exports.SOMOS_SUBSCRIPTION_NAME = 'Plurall Adapta';
exports.GOSTUDENT_SUBSCRIPTION_NAME = 'goStudentLearning-Advanced';
exports.USER_ID_WITH_PREMIUM_SUBSCRIPTION = '7333564';
exports.GLOBAL_SUBSCRIPTION_PURCHASES_VARIANCE = 25;
var MANAGED_BY;
(function (MANAGED_BY) {
    MANAGED_BY["internal"] = "internal";
    MANAGED_BY["misSyncService"] = "misSyncService";
})(MANAGED_BY = exports.MANAGED_BY || (exports.MANAGED_BY = {}));
exports.SKIP_WEBHOOK_CUSTOMER_EMAIL = 'skipwebhook@mail.com';
exports.TEST_SUBSCRIPTION_DESCRIPTION_KEYWORDS = ['GoStudent'];
const SUBSCRIPTION_EVENT_TYPES_LIST = [
    'create',
    'stopAutoRenew',
    'restartAutoRenew',
    'delete',
    'reassign',
    'upgrade',
    'downgrade',
    'renew',
    'externalRefund',
    'externalCharge',
    subscriptionUpdate_1.SubscriptionUpdateType.requestPause,
    subscriptionUpdate_1.SubscriptionUpdateType.requestUnpause,
    subscriptionUpdate_1.SubscriptionUpdateType.pause,
    subscriptionUpdate_1.SubscriptionUpdateType.unpause,
    subscriptionUpdate_1.SubscriptionUpdateType.applyCoupon
];
exports.SUBSCRIPTION_EVENT_TYPE = SUBSCRIPTION_EVENT_TYPES_LIST.reduce((acc, it) => ({ ...acc, [it]: `${it}` }), {});
exports.PAYMENT_IN_PROGRESS_TO_EVENT_NAME_MAP = Object.freeze({
    [exports.PAYMENT_IN_PROGRESS_STATES.create]: exports.SUBSCRIPTION_EVENT_TYPE.create,
    [exports.PAYMENT_IN_PROGRESS_STATES.upgrade]: exports.SUBSCRIPTION_EVENT_TYPE.upgrade
});
__exportStar(require("./subscriptionUpdate"), exports);
//# sourceMappingURL=index.js.map